// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/solid/x-mark.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'x-mark',
  version: 'solid',
  paths: [
    {
      d: 'M7.536 6.264a.9.9 0 0 0-1.272 1.272L10.728 12l-4.464 4.464a.9.9 0 1 0 1.272 1.272L12 13.272l4.464 4.464a.9.9 0 1 0 1.272-1.272L13.272 12l4.464-4.464a.9.9 0 0 0-1.272-1.272L12 10.728 7.536 6.264',
    },
  ],
}
